import React from 'react';
import { otherCalculators_Fr } from '../ConstantsOtherCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Autres calculatrices et outils pratiques en ligne';
const DESCRIPTION = 'Decouvrez des outils utiles au quotidien: generateur de mot de passe, compteur, generateur aleatoire, calculs divers et utilitaires rapides en francais.';
const KEYWORDS = 'outils pratiques en ligne, generateur mot de passe, generateur aleatoire, compteur, calculatrice utile';
const OG_URL = 'https://do-calculate.com/fr/other-calculators/';

function OtherCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Une selection d outils rapides pour les petits besoins du quotidien, dans une seule page facile a parcourir.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {otherCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default OtherCalculatorsList;
